import classNames from "classnames/dedupe";
import type { Quote } from "../../QuoteCards/types";
import { ProductInfo } from "../../shared/ProductInfo";
import { Coverage } from "../../QuoteCards/QuoteCard/Coverage";

export type QuoteSummaryProps = {
  quote: Quote;
};

export const QuoteSummary = (props: QuoteSummaryProps) => {
  const { quote } = props;
  const classes = classNames("mobius", "mobius-quote-summary");

  return (
    <div role="listitem" className={classes}>
      <ProductInfo
        logo={quote.insurerLogo}
        productTitle={quote.productDescription || quote.covers[0].displayName}
        premium={quote.premium}
        policyStartDate={quote.policyStartDate}
      >
        <Coverage
          covers={quote.covers}
          displayVariant="qcp"
          helpText={quote.helpText}
        />
      </ProductInfo>
    </div>
  );
};
